'use client';

export default function PromotionTopAd() {
  return null;
}
